import type { Lang, LocaleString } from './grab'

export const humanReadableDelay = (delayInMinutes: number, lang: Lang): string => {
  if (delayInMinutes % (24 * 60 * 7) === 0) {
    const delayInWeeks = Math.ceil(delayInMinutes / (24 * 60 * 7))
    return `${delayInWeeks} ${I18n.WEEK[lang]}${delayInWeeks > 1 ? 's' : ''}`
  }

  if (delayInMinutes % (24 * 60) === 0) {
    const delayInDays = Math.ceil(delayInMinutes / (24 * 60))
    return `${delayInDays} ${I18n.DAY[lang]}${delayInDays > 1 ? 's' : ''}`
  }

  if (delayInMinutes % 60 === 0) {
    const delayInHours = Math.ceil(delayInMinutes / 60)
    return `${delayInHours} ${I18n.HOUR[lang]}${delayInHours > 1 ? 's' : ''}`
  }
  return `${delayInMinutes} ${I18n.MINUTE[lang]}${delayInMinutes > 1 ? 's' : ''}`
}

export const I18n = {
  OK: { fr: 'Ok', en: 'Ok' },
  YES: { fr: 'Oui', en: 'Yes' },
  NO: { fr: 'Non', en: 'No' },
  CANCEL: { fr: 'Annuler', en: 'Cancel' },
  CLOSE: { fr: 'Fermer', en: 'Close' },
  FILTERS: { fr: 'Filtres', en: 'Filters' },
  OPEN: { fr: 'Ouvrir', en: 'Open' },
  PLACES: { fr: 'Lieux', en: 'Places' },
  PROGRAMS: { fr: 'Programmes', en: 'Programs' },
  SHOW_MORE: { fr: 'Voir plus', en: 'Show more' },
  SHOW_ALL: { fr: 'Voir tout', en: 'Show all' },
  SHOW_LESS: { fr: 'Voir moins', en: 'Show less' },
  SPECIALTIES: { fr: 'Spécialités', en: 'Specialities' },
  GUEST_TYPES: { fr: "Types d'invité", en: 'Guest types' },
  GUEST_EMTPY: { fr: 'AUCUN RÉSULTAT', en: 'NO RESULT' },
  VIDEO: { fr: 'Vidéo', en: 'Video' },
  EVENT_CALENDAR: { fr: 'Agenda', en: 'Calendar' },
  EVENT_CALENDAR_HINT: {
    fr: "Ajouter l'événement à votre calendrier, ouvre une autre application",
    en: 'Add the event to your calendar, opens another app.',
  },
  EVENT_ATTEND: { fr: 'Participer', en: 'Attend' },
  EVENT_UNATTEND: { fr: 'Se désengager', en: 'Opt out' },
  EVENT_RATE: { fr: 'Noter', en: 'Rate' },
  EVENT_RATING_TITLE: { fr: 'Notez cet évènement', en: 'Rate this event' },
  EVENT_RATING_COMMENT: { fr: 'Ajoutez un commentaire...', en: 'Add a comment...' },
  EVENT_RATING_ERROR: { fr: 'Une erreur est survenue', en: 'Errored while sending' },
  EVENT_RATING_SUCCESS: { fr: 'Note envoyée avec succès', en: 'Rating successfully sent' },
  EVENT_TICKETING: { fr: 'Billetterie', en: 'Ticketing' },
  EVENT_LINKED_EVENTS: { fr: 'Évènements liés', en: 'Related events' },
  EVENT_SOLD_OUT: { fr: 'Complet', en: 'Sold out' },
  FAVORITE_EMPTY: { fr: 'Ajoutez des favoris et créez votre propre programme', en: 'Add likes and create your own program' },
  FAVORITE_TITLE: { fr: 'Favoris', en: 'Likes' },
  FAVORITE_PICKER_EVENT: { fr: 'Évènements', en: 'Event' },
  FAVORITE_PICKER_GUEST: { fr: 'Invités', en: 'Guest' },
  ARTIST_SOCIAL_TITLE: (artistName: string) => ({ fr: `Ne ratez aucune info de ${artistName}`, en: `Don’t miss any info from ${artistName}` }),
  NOTIFICATION_TITLE: { fr: 'Notifications', en: 'Notifications' },
  NOTIFICATION_EMPTY: { fr: 'Aucune notification pour le moment', en: 'No notification yet' },
  NOTIFICATION_RESET_FILTERS: { fr: 'Réinitialiser les filtres', en: 'Reset filters' },
  NOTIFICATION_TOPICS: { fr: 'Cibles', en: 'Topics' },
  NOTIF_SETTINGS_TITLE: { fr: 'Paramètres des notifications', en: 'Notification settings' },
  NOTIF_SETTINGS_DESC_1: {
    fr: 'L’application peut vous tenir informé des nouvelles importantes et des changements de programme grâce aux ',
    en: 'The app can keep you informed about important news and schedule changes thanks to ',
  },
  NOTIF_SETTINGS_DESC_2: { fr: 'notifications push. ', en: 'push notifications. ' },
  NOTIF_SETTINGS_DESC_3: {
    fr: 'Des modifications peuvent toujours être apportées ultérieurement dans les paramètres de l’application.',
    en: 'Changes can always be made later in the app settings.',
  },
  NAVIGATOR_NOTIFICATION_TITLE: { fr: 'Notifications', en: 'Notifications' },
  NAVIGATOR_HOME_TITLE: { fr: 'Accueil', en: 'Home' },
  NAVIGATOR_PROGRAMMATION_TITLE: { fr: 'Programmation', en: 'Programm' },
  NAVIGATOR_LIKES_TITLE: { fr: 'Favoris', en: 'Likes' },
  NAVIGATOR_MENU_TITLE: { fr: 'Menu', en: 'Menu' },
  NEXT: { fr: 'Suivant', en: 'Next' },
  MAP_TITLE: { fr: 'Plan', en: 'Plan' },
  MAP_LOCATE: { fr: 'Localiser', en: 'Locate' },
  MAP_LOCATE_BUTTON: { fr: 'Voir sur le plan', en: 'See on map' },
  MAP_PROGRAM: { fr: 'Voir le programme', en: 'See program' },
  MAP_SHARE_MY_POSITION_TITLE: { fr: 'Partager ma position', en: 'Share my location' },
  MAP_SHARE_MY_POSITION_TEXT: { fr: 'Voici ma position', en: 'Here my location' },
  MAP_SHARED_POSITION: { fr: 'Retrouve moi ici', en: 'Find me here' },
  PRACTICAL_INFO_LIST_TITLE: { fr: 'Infos pratiques', en: 'Practical info' },
  PROGRAM_NO_RESULT: { fr: 'AUCUN RÉSULTAT', en: 'NO RESULT' },
  PROGRAM_RESET_FILTERS: { fr: 'Réinitialiser les filtres', en: 'Reset filters' },
  PRIVATE_PROGRAM_MODAL_TITLE: { fr: 'Accès restreint', en: 'Restricted access' },
  PRIVATE_PROGRAM_MODAL_DESCRIPTION: (programName: string) => ({
    fr: `L'accès à cet espace est restreint, veuillez préciser le code qui vous a été communiqué pour le programme "${programName}"`,
    en: `The access to this space is restricted, please enter the password for the program "${programName}"`,
  }),
  PRIVATE_PROGRAM_MODAL_ERROR: { fr: 'Mauvais mot de passe', en: 'Wrong password' },
  NOTIF_REMINDER_DELAY_LABEL: (delayInMinutes: number) => ({
    fr: `${humanReadableDelay(delayInMinutes, 'fr')} avant`,
    en: `${humanReadableDelay(delayInMinutes, 'en')} before`,
  }),
  MINUTE: { fr: 'minute', en: 'minute' },
  HOUR: { fr: 'heure', en: 'hour' },
  DAY: { fr: 'jour', en: 'day' },
  WEEK: { fr: 'semaine', en: 'week' },
  NOTIF_REMINDER_TITLE: { fr: 'Rappels événements à venir', en: 'Reminders of upcoming events' },
  NOTIF_NO_REMINDER_HINT: {
    fr: `Aucune notification ne sera envoyée avant le début d'un évènement mis en favoris`,
    en: `No notification will be sent before the start of a favorited event`,
  },
  NOTIF_REMINDER_HINT: (delayInMinutes: number) => ({
    fr: `Une notification sera programmée ${humanReadableDelay(delayInMinutes, 'fr')} avant le début d'un évènement mis en favoris`,
    en: `A notification will be scheduled ${humanReadableDelay(delayInMinutes, 'en')} before the start of a favorited event`,
  }),
  NOTIF_REMINDER_BODY: (title: string, delayInMinutes) => ({
    fr: `${title} débute dans ${humanReadableDelay(delayInMinutes, 'fr')}`,
    en: `${title} starts in ${humanReadableDelay(delayInMinutes, 'en')}`,
  }),
  PHOTO_CREDIT: (credit: string) => ({ fr: `Crédit photo © ${credit}`, en: `Photo credit © ${credit}` }),
  CONTACT: { fr: 'Coordonnées', en: 'Contact' },
  AUTHORIZATION_TITLE: { fr: 'Demande de permission', en: 'Permission request' },
  AUTHORIZATION_GEOLOCATION_MESSAGE: { fr: 'Voulez vous donner votre position', en: 'Do you want to give access to your location ?' },
  AUTHORIZATION_STORAGE_MESSAGE: {
    fr: "Authoriser l'accèss à vos dossiers pour y sauvegarder des documents ?",
    en: 'Do you give access to your folders to save files ?',
  },
  NO_AUTHORIZATION_STORAGE: { fr: 'Impossible de télécharge le fichier sans permission', en: 'Cannot download file without permission.' },
  MAP_GEOLOCATION_MARKER: { fr: 'Votre position', en: 'Your position' },
  MAP_MARKER_TIP: {
    en: 'Add your own pins by long pressing on the map',
    fr: 'Ajoutez vos propres repères en faisant un appui long sur la carte',
  },
  MAP_MARKER_DEFAULT: { en: 'My pin', fr: 'Mon épingle' },
  DOWNLOAD_ALERT_TITLE: { fr: 'Téléchargement fini', en: 'Download finished' },
  DOWNLOAD_ALERT_MESSAGE: (filename: string) => ({
    fr: `Le fichier "${filename}" est disponible dans le dossier Téléchargement`,
    en: `The file "${filename}" is available in the Download folder.`,
  }),
  SEARCH_LABEL: (title: string) => ({
    fr: `Commencez une recherche textuelle dans ${title}`,
    en: `Start a text search inside ${title}`,
  }),
  FILTER_LABEL: {
    fr: 'Ouvrir le panneau des filtres de recherche.',
    en: 'Open search filters panel.',
  },
  FILTER_COUNTER_LABEL: (qt: number) => ({
    fr: qt <= 0 ? `Aucun filtres actifs.` : qt === 1 ? `Un filtre actif.` : `${qt} filtres actifs.`,
    en: qt <= 0 ? `No active filters.` : qt === 1 ? `One active filter.` : `${qt} active filtres.`,
  }),
  VALIDATE_FILTER: (qt: number) => ({
    fr: `Valider les ${qt} filtres selectionnés.`,
    en: `Validate the ${qt} filters selected`,
  }),
  NO_AVAILABLE_FILTER: { fr: "Aucun filtre n'est disponible.", en: 'No available filter' },
  UPDATE_BUTTON_TITLE: {
    fr: 'Nouvelles données disponibles',
    en: 'New data available',
  },
  UPDATE_BUTTON_TEXT: {
    fr: 'Appuyer ici pour mettre à jour',
    en: 'Press here to update',
  },
  UPDATE_BUTTON_ERROR: {
    fr: 'Une erreur est survenue, veuillez réessayer',
    en: 'An error occured, please retry',
  },
  UPDATE_BUTTON_LOADING: {
    fr: 'Chargement des données en cours',
    en: 'Data loading',
  },
  UPDATE_BUTTON_A11Y: {
    fr: 'Nouvelles données disponibles, appuyer ici pour mettre à jour',
    en: 'New data available, press here to update',
  },
  PRIVATE_SECTION: {
    fr: 'Section privée, saisissez le mot de passe',
    en: 'Private section, enter the password',
  },
  PRIVATE_SECTION_UNLOCK_A11Y: {
    fr: 'Valider le mot de passe',
    en: 'Validate password',
  },
  EARLY_RATING: {
    fr: "Êtes-vous sûr de vouloir envoyer votre avis, l'événement ne semble pas terminé ?",
    en: 'Are you sure you want to send your rating, the event seems not yet finished ?',
  },
  CHAT: {
    fr: 'Discussions',
    en: 'Chat',
  },
  CHAT_INTRO: {
    fr: 'Scanner le QR code de votre billet pour vous connecter au chat',
    en: 'Scan the QR code on your ticket to connect to the chat',
  },
  TICKETS_ASK_EMAIL: {
    fr: "Entrez l'adresse email utilisée comme propriétaire du billet",
    en: 'Enter the email address used as the owner of the ticket',
  },
  TICKETS_ASK_ORDER_NUMBER: {
    fr: 'Entrez votre numéro de commande',
    en: 'Enter your order number',
  },
  TICKETS_LOGIN_ERROR: {
    fr: 'Erreur de connexion, veuillez réessayer',
    en: 'Login error, please retry',
  },
  TICKETS_VALIDATION_ERROR: {
    fr: 'Veuillez remplir tous les champs',
    en: 'Please fill all fields',
  },
  TICKETS_LOGIN: {
    fr: 'Connexion',
    en: 'Login',
  },
  TICKETS_LOGOUT: {
    fr: 'Déconnexion',
    en: 'Logout',
  },
  TICKETS_LOGGED_OUT: {
    fr: 'Vous êtes bien déconnecté',
    en: 'You are successfully disconnected',
  },
  CHAT_RESCAN: {
    fr: 'Scanner à nouveau',
    en: 'Scan again',
  },
  CHAT_ASK_CAMERA_PERMISSION: {
    fr: "Autoriser l'accès à la caméra pour scanner le QR code",
    en: 'Allow access to the camera to scan the QR code',
  },
  CHAT_NOTIFICATION_TITLE: {
    fr: 'Discussions Chapito',
    en: 'Chat Chapito',
  },
  CHAT_NOTIFICATION_BODY: {
    fr: 'Vous avez un nouveau message',
    en: 'You have a new message',
  },
  MY_TICKETS: {
    fr: 'Mes tickets',
    en: 'My tickets',
  },
  MY_TICKETS_LOGIN_TITLE: {
    fr: 'Connexion',
    en: 'Login',
  },
  MY_TICKETS_EMAIL: {
    fr: 'Email',
    en: 'Email',
  },
  MY_TICKETS_ORDER_NUMBER: {
    fr: 'N° de commande',
    en: 'Order number',
  },
  MY_TICKETS_TICKET: {
    fr: 'Mon ticket',
    en: 'My ticket',
  },
  MY_TICKETS_FIRST_NAME: {
    fr: 'Prénom',
    en: 'First name',
  },
  MY_TICKETS_LAST_NAME: {
    fr: 'Nom',
    en: 'Last name',
  },
  MY_TICKETS_QR_CODE_FULL_SCREEN: {
    fr: 'Affichage du QR code en plein écran',
    en: 'Full screen QR code display',
  },
  MY_TICKETS_QR_CODE_FOR_TICKET: (ticketNumber: string) => ({
    fr: `QR code pour le ticket ${ticketNumber}`,
    en: `QR code for ticket ${ticketNumber}`,
  }),
  MY_TICKETS_TICKET_FOR: (firstName: string, lastName: string, ticketNumber: string) => ({
    fr: `Ticket pour ${firstName} ${lastName}, numéro de ticket ${ticketNumber}`,
    en: `Ticket for ${firstName} ${lastName}, ticket number ${ticketNumber}`,
  }),
  MY_TICKETS_TICKET_STATUS_STALE: {
    fr: 'CLOS',
    en: 'CLOSED',
  },
  MY_TICKETS_FREE_SEATING: {
    fr: 'PLACEMENT LIBRE',
    en: 'FREE SEATING',
  },
  MY_TICKETS_TICKET_SEAT_RANK: (rank: string) => ({
    fr: `Rang : ${rank}`,
    en: `Rank: ${rank}`,
  }),
  MY_TICKETS_TICKET_SEAT_PLACE: (place: string) => ({
    fr: `Place : ${place}`,
    en: `Seat: ${place}`,
  }),
  MY_TICKETS_TICKET_SEAT_PRICE: (price: string) => ({
    fr: `Prix TTC : ${price} €`,
    en: `Price including tax: ${price} €`,
  }),
  MY_TICKETS_TICKET_LABEL: (orderNumber: string, ticketNumber: string) => ({
    fr: `Commande n°${orderNumber} / Billet n°${ticketNumber}`,
    en: `Order #${orderNumber} / Ticket #${ticketNumber}`,
  }),
} as const satisfies Record<string, LocaleString | ((...params: any[]) => LocaleString)>
